import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { MarketBanner } from '@market/react';
import { getCountryCode } from 'utilities/locales';
import { SOFTWARE_SUBSCRIPTION_STATES } from 'utilities/software';
import { SOFTWARE_BASE_PRODUCT_KEYS } from 'constants/software';

const BASE_KEY = 'notice.software.productPage';

const SoftwareAddOnBanner = ({
  softwareBaseProductKey,
  subscriptionState,
  footnote = '',
  variant = 'info',
  softwareName,
  trialEndDate,
  ...translationOptions
}) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const countryCode = getCountryCode();

  if (!softwareBaseProductKey || !subscriptionState) {
    return null;
  }

  const getKey = () => {
    let subscriptionStateKey = subscriptionState;

    // for non US countries, the superset messaging does not apply for kisok software
    // so we need to override it with the regular active subscription messaging
    if (
      countryCode.toUpperCase() !== 'US' &&
      softwareBaseProductKey === SOFTWARE_BASE_PRODUCT_KEYS.SW_KIOSK &&
      subscriptionState ===
        SOFTWARE_SUBSCRIPTION_STATES.SUBSCRIPTION_WITH_ACTIVE_SUPERSET
    ) {
      subscriptionStateKey = SOFTWARE_SUBSCRIPTION_STATES.ACTIVE_SUBSCRIPTION;
    }

    const key = `${BASE_KEY}.${subscriptionStateKey?.toLowerCase()}`;

    if (i18n.exists(key)) {
      return key;
    }

    return null;
  };

  const key = getKey();

  if (!key) {
    return null;
  }

  return (
    <MarketBanner variant={variant} style={{ margin: theme.spacing(2, 0) }}>
      <p
        data-market-features="html-styles"
        dangerouslySetInnerHTML={{
          __html: `${t(key, {
            ...translationOptions,
            softwareName,
            monthOfYear: trialEndDate?.month_of_year,
            dayOfMonth: trialEndDate?.day_of_month,
          })}<sup>${footnote}</sup>`,
        }}
      />
    </MarketBanner>
  );
};

export default SoftwareAddOnBanner;
